import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Header from "./../../Header";
import $ from "jquery";

import CryptoJS from "crypto-js";
import config from "react-global-configuration";

import TextField from '@material-ui/core/TextField';

import { AgGridReact } from "ag-grid-react";
import "./feature.css";

import { createFilterOptions }  from '@material-ui/lab/Autocomplete';

import CustomAutocomplete from  "../CustomAutocomplete";

class AddFeature extends Component {
  constructor(props) {
    super(props);
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(localStorage.getItem("encdata"), 0)
      : "";

    this.state = {
      redirect: false,
      activePage: 1,
      item_count: '',
      userAuthKey: has_local_data ? localdata.user_key : "",
      apiUrl: this.decryptconfigdata("apiUrl"),
      userId: has_local_data ? localdata.user_id : "",
      user_Name: has_local_data ? localdata.user_name : "",
      loading:0,
      form_name: '',
      waiting: '',
      error_message:'',
      success_message:'',
      errors: {},
      formData:{'muvi6_r1' : "1",'feature':'','description':'','sub_feature':''},
      feature_data:{},
      pod:[],
      product:[],
      app:[],
      all_templates:[], //ER#76237 Add 'Template' form field
      selected_product_list:[],
      selected_pod_list:[],
      selected_app_list:[],
      selected_templates:[],//ER#76237 Add 'Template' form field
      form_type:"",
      linkData :{'display_link':'','display_text':''},
    };

  }

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  rawjsonparse(findresponse, flg) {
    return findresponse;
  }

  componentDidMount() {
    document.title = "Intranet | List Feature";
    if (!localStorage.getItem('userLogin')) {
      this.setState({ redirect: true });
    }
    this.GetFeatureFormData();
  }

  GetFeatureFormData() {
      fetch(this.state.apiUrl + '/AddFeature/getFeatureFromData', {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(this.state),
      })
        .then((Response) => Response.json())
        .then((findresponse) => {
        // findresponse = this.decrypt(findresponse, 1);
          console.log("Dateaa" + findresponse);
          this.setState({
            pod: findresponse.pods,
            app: findresponse.app,
            product: findresponse.products,
            all_templates: findresponse.all_templates,
            //loading:0,
          });
      });
  }

  showAddFeature(){
      this.setState({
        waiting:'',
        errors: {},
        success_message:'',
        form_name:'Add',
        selected_pod_list:[],
        selected_product_list:[],
        formData :{'pod':'','product':[],'feature_page':'','help_article':'','feature':''}
      });
  }

  showLinkModal(type){
    this.setState({
      waiting:'',
      errors: {},
      link_type:type,
      form_type:'Add',
      linkData :{'display_link':'','display_text':''}
    });
    
  }

  onChangeLink(type,e){

    let linkData = this.state.linkData;
    let errors = this.state.errors;

    linkData[type] = e.target.value;

    errors[type] = '';

    this.setState({
      linkData: linkData,
      errors:errors,
    });
  }

  onChangeFrom(type,e) {

    var formData = this.state.formData;
    var errors = this.state.errors;
    if(type == 'product'){
      let product = [];
      e.forEach((element) => {
        product.push(element.product_key);
      });
      
      this.setState({
        selected_product_list: e
      });
      
      formData[type] = product;

    }else if(type == 'pod'){

      let pod = [];
      
      e.forEach((element) => {
        pod.push(element.id);
      });

      this.setState({
        selected_pod_list: e
      });

      formData[type] = pod;

    }else if(type == 'app'){

      console.log(e);

      let app = [];
      
      e.forEach((element) => {
        app.push(element.id);
      });

      this.setState({
        selected_app_list: e
      });

      formData[type] = app;

    }else if(type == 'all_templates'){

      let templates = [];
      
      e.forEach((element) => {
        templates.push(element.id);
      });

      this.setState({
        selected_templates: e
      });

      formData[type] = templates;

    }   
    else if(type == 'muvi6_r1'){

      formData[type] = e;

    }else{
      formData[type] = e.target.value;
    }

    console.log('fd',formData);

    errors[type] = '';
    this.setState({
      formData: formData,
      errors:errors,
    });
    
  }

  handleValidation() {
    let formData = this.state.formData;
    let errors = {};
    let formIsValid = true;

    if (!formData["feature"] || !formData["feature"].trim()) {
      formIsValid = false;
      errors["feature"] = "Please enter feature name";

    }else if (formData["feature"].length > 150) {
      formIsValid = false;
      errors["feature"] = "Feature Name must not be greater than 150 character length";
    }

    if (formData["sub_feature"] || formData["sub_feature"].trim()) {
      if (formData["sub_feature"].length > 150) {
        formIsValid = false;
        errors["sub_feature"] = "Sub Feature must not be greater than 150 character length";
      }
    }

    if (!formData["pod"] || formData["pod"] == "") {
      formIsValid = false;
      errors["pod"] = "Please choose a pod";
    }
    
    if (!formData["product"] || formData["product"] == "") {
      formIsValid = false;
      errors["product"] = "Please choose a product";
    }

    if (!formData["app"] || formData["app"] == "") {
      formIsValid = false;
      errors["app"] = "Please choose an app";
    }

    this.setState({ errors: errors });
    
    return formIsValid;

  }

  handleLinkValidation(){

    let linkData = this.state.linkData;
    let errors = {};
    let formIsValid = true;

    if (!linkData["display_text"] || !linkData["display_text"].trim()) {
      formIsValid = false;
      errors["display_text"] = "Please enter text to display";
    }else if (linkData["display_text"].length > 50) {
      formIsValid = false;
      errors["display_text"] = "Text must not be greater than 50 character length";
    }

    if (!linkData["display_link"] || !linkData["display_link"].trim()) {
      formIsValid = false;
      errors["display_link"] = "Please enter a url";
    }else if (!/^(ftp|http|https):\/\/[^ "]+$/.test(linkData["display_link"])) {
      formIsValid = false;
      errors["display_link"] = "Please enter a url";
    }

    this.setState({ errors: errors });
    
    return formIsValid;
  }


  AddLink(){

    let is_valid = this.handleLinkValidation();

    if (!is_valid) {
      this.setState({waiting:''});
      return false;
    }

    this.setState({waiting:'loading'});

    let errors = {};
    let form_type = this.state.form_type;
    let link_type = this.state.link_type;
    let linkData = this.state.linkData;
    let formData = this.state.formData;
    let fromLinkData = this.state.formData[link_type] ? this.state.formData[link_type] : [];
    let editindex = this.state.editindex ? this.state.editindex : 0;
    let fd = {};

    fd['link_type'] = link_type;

    fd['links'] = linkData;

    fd['is_validate'] = 1;

    fetch(this.state.apiUrl + "/AddFeature/FeatureLinks", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(fd),
    })
    .then((Response) => Response.json())
    .then((findresponse) => {

      if (findresponse.code == 200) {
          //console.log("Response Data", findresponse.data);
          if(form_type == "Edit"){
            //formData[link_type][editindex] = findresponse.data;
            //formData[link_type][editindex] = linkData;

          }else if(form_type == "Add"){

            fromLinkData.unshift(linkData);

            formData[link_type] = fromLinkData;
          }

          this.setState({formData:formData});

          let copiedObject = JSON.parse(JSON.stringify(this.state.formData));

          this.setState({
            feature_data:copiedObject,
            waiting:''
          });

          window.$("#addLink").modal('hide');

      }else if(findresponse.code == 401){
        var status = findresponse.status;
        errors[status] = findresponse.msg;
        this.setState({waiting:'',errors: errors });

      }else {
        var status = findresponse.status;
        errors['link'] = findresponse.msg;        
        this.setState({waiting:'',errors: errors });
      }

    }).catch(function(error) {                    

      errors['link'] = error;
      this.setState({waiting:'',errors: errors });

    });

  }
 
  RemoveLink(link_type,index){

    let formData = this.state.formData;

    let fromLinkData = this.state.formData[link_type] ? this.state.formData[link_type] : [];

    console.log(fromLinkData);

    fromLinkData.splice(index, 1);

    console.log(fromLinkData);

    formData[link_type] = fromLinkData;
    
    this.setState({formData:formData});

    let copiedObject = JSON.parse(JSON.stringify(this.state.formData));

    this.setState({
      feature_data:copiedObject
    });
  }

  ShowEditLink(link_type,index){

    let formData = this.state.formData;

    let fromLinkData = this.state.formData[link_type] ? this.state.formData[link_type] : [];

    let linkData = fromLinkData[index];

    this.setState({linkData:linkData,form_type:'Edit',editindex:index,link_type:link_type});
  }

  ResetForm(){
    window.parent.location = window.parent.location.href;
  }

  AddFeature(){

    this.setState({waiting:'loading'});

    var obj = this;

    let errors = {};

    let is_valid = this.handleValidation();

    if (!is_valid) {
      obj.setState({waiting:''});
      return false;
    }


    fetch(this.state.apiUrl + "/AddFeature/AddFeature", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(this.state.formData),
    })
    .then((Response) => Response.json())
    .then((findresponse) => {

      if (findresponse.code == 200) {

        window.$("#quiz_Pass").modal('show');

        this.setState({ success_message: findresponse.msg,waiting:'',formData:{}});

      } else if(findresponse.code == 401){

        var status = findresponse.status;

        errors[status] = findresponse.msg;

        this.setState({waiting:''});

      }

      this.setState({ errors: errors });
     
      return false;

    }).catch(function(error) {                    

      errors['form'] = error;

      console.log(error);
    });
    
	}

  getLinks(type){

    let links = this.state.feature_data[type] ? this.state.feature_data[type] : [];

    return (  

      <ul>

      {this.state.feature_data[type] ? 

          this.state.feature_data[type].map
              ((data, key) =>
              <li className="viewDemo" key = {key}>
                <span className="onlyText" title="Edit Link" data-toggle="modal" data-target="#addLink"  onClick={() => this.ShowEditLink(type,key)} dangerouslySetInnerHTML={{ __html: data.display_text }}></span> 
                <span className="onlyIcon" title="Delete" data-toggle="modal" data-target="#delete-link" onClick={() => this.RemoveLink(type,key)}>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.98853 3.25L3.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M3.98853 3.25L9.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>                                        
                </span>
            </li>
          )

        : "" }

        {links && links.length < 10 ? 

        <li className="viewAdd" title="Add Link" data-toggle="modal" data-target="#addLink" onClick={() => this.showLinkModal(type)}>
            <span>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.0001 29.3334C23.3639 29.3334 29.3335 23.3638 29.3335 16C29.3335 8.63623 23.3639 2.66669 16.0001 2.66669C8.63629 2.66669 2.66675 8.63623 2.66675 16C2.66675 23.3638 8.63629 29.3334 16.0001 29.3334Z" fill="white" stroke="black" strokeOpacity="0.12" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 11.25V20.7501" stroke="#666666" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11.25 16H20.7501" stroke="#666666" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
        </li>
        :"" 

        }
      </ul>
    )


  }

  getFeatureDetails() {

    if (this.state.loading) {
          return (
              <div>
                  <div className="loader-new"></div>
              </div>
          )
      }
      else {
        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
        });
          return (
          <div>
            <div className="featureInformation">
                <div className="topfeatureInformation">
                    <div className="informationTitle">Feature Information</div>
                </div>
                <div className="row mt20">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="inputGroup">
                            <label>Feature Name <span className="star">*</span></label>
                            <input type="text" className="form-control" id="feature" autoComplete="off" placeholder="Please Write Here" value={this.state.formData['feature']}  onChange={(e) => this.onChangeFrom('feature',e)} />
                            <span className="error">{this.state.errors["feature"]}</span>
                        </div>
                    </div>
                </div>
                <div className="row mt20">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="inputGroup">
                            <label>Description</label>
                            <textarea placeholder="Add a Description" className="textareaCls" autoComplete="off" onChange={(e) => this.onChangeFrom('description',e)} ></textarea>
                            <span className="error">{this.state.errors["description"]}</span>
                        </div>
                    </div>
                </div>
                <div className="row mt20">
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="inputGroup">
                                    <label>Sub Feature</label>
                                    <input type="text" className="form-control" id="sub_feature" autoComplete="off" placeholder="Please Write Here" value={this.state.formData['sub_feature']}  onChange={(e) => this.onChangeFrom('sub_feature',e)} />
                                    <span className="error">{this.state.errors["sub_feature"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="inputGroup">
                                    <label>Muvi 6 R1</label>
                                    <div className="checkInput">
                                      <div className="form-check">
                                          <label className="cont">
                                              <input type="radio" id="checkall" name="muvi6_r1"  onChange={(e) => this.onChangeFrom('muvi6_r1','1')} checked={this.state.formData['muvi6_r1'] === "1"} />
                                              <span className="checkmark"></span>
                                          </label>
                                          <label className="titleName">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <label className="cont">
                                              <input type="radio" id="checkall"  name="muvi6_r1" onChange={(e) => this.onChangeFrom('muvi6_r1','0')} checked={this.state.formData['muvi6_r1'] === "0"} />
                                              <span className="checkmark"></span>
                                            </label>
                                            <label className="titleName">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt20">
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="inputGroup">
                                <label htmlFor="POD">POD<span className="star">*</span></label>
                                <CustomAutocomplete
                                    multiple
                                    options={this.state.pod}
                                    ChipProps={{ deleteIcon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.98853 3.25L3.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M3.98853 3.25L9.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>}}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, value) =>
                                        this.onChangeFrom('pod',value)
                                    }
                                    value={this.state.selected_pod_list}
                                    defaultValue={this.state.selected_pod_list}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    filterOptions={filterOptions}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select"
                                    />
                                    )}
                                />
                                <span className="error">{this.state.errors["pod"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="inputGroup">
                                <label htmlFor="Product">Product<span className="star">*</span></label>
                                <CustomAutocomplete
                                    multiple
                                    id="product"
                                    options={this.state.product}
                                    ChipProps={{ deleteIcon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.98853 3.25L3.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M3.98853 3.25L9.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>}}
                                    value={this.state.selected_product_list}
                                    defaultValue={this.state.selected_product_list}
                                    getOptionSelected={(option, value) => option.product_key === value.product_key}
                                    getOptionLabel={(option) => option.product_name}
                                    filterSelectedOptions
                                    onChange={(event, value) =>
                                    this.onChangeFrom('product',value)
                                    }
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select"
                                    />
                                    )}
                                />
                                <span className="error">{this.state.errors["product"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt23">
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="inputGroup">
                                <label htmlFor="APP">APP<span className="star">*</span></label>
                                <CustomAutocomplete
                                    multiple
                                    options={this.state.app}
                                    ChipProps={{ deleteIcon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.98853 3.25L3.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M3.98853 3.25L9.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>}}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, value) =>
                                        this.onChangeFrom('app',value)
                                    }
                                    value={this.state.selected_app_list}
                                    defaultValue={this.state.selected_app_list}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    filterOptions={filterOptions}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select"
                                    />
                                    )}
                                />
                                <span className="error">{this.state.errors["app"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ER#76237 Add 'Template' form field */}
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="inputGroup">
                                <label htmlFor="Template">Template</label>
                                <CustomAutocomplete
                                    multiple
                                    options={this.state.all_templates}
                                    ChipProps={{ deleteIcon: <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.98853 3.25L3.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M3.98853 3.25L9.98853 9.25" stroke="#333333" strokeOpacity="0.6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>}}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, value) =>
                                        this.onChangeFrom('all_templates',value)
                                    }
                                    value={this.state.selected_templates}
                                    defaultValue={this.state.selected_templates}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    filterOptions={filterOptions}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select"
                                    />
                                    )}
                                />
                                
                                </div>
                            </div>
                        </div>
                    </div>
                     {/* ER#76237 Add 'Template' form field end*/}
                </div>
            </div>
            <div className="featureLinks">
                <div className="linksTitle">feature Links</div>
                <div className="singleLine mt15">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Feature Demo Recording</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                            
                                {this.getLinks('feature_demo')}
                            
                        </div>
                    </div>
                </div>
                <div className="singleLine mt10">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Specs</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                          
                            {this.getLinks('specs')}
                            
                        </div>
                    </div>
                </div>
                <div className="singleLine mt10">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Marketing Briefs</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                            
                            {this.getLinks('marketing_briefs')}
                            
                        </div>
                    </div>
                </div>
                <div className="singleLine mt10">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Help Article</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                            
                            {this.getLinks('help_article')}
                            
                        </div>
                    </div>
                </div>
                <div className="singleLine mt10">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Feature Page</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                            
                            {this.getLinks('feature_page')}
                            
                        </div>
                    </div>
                </div>
                <div className="singleLine mt10">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 leftText">Demo Video</div>
                        <div className="col-md-8 col-lg-8 rightBox">
                            
                            {this.getLinks('demo_video')}
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt30 mb10">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="addFeatureBtn-Group">
                        {this.state.waiting ?  <button type="submit" className="saveBtn disabled" ><div><i className="fa fa-spinner fa-spin"></i><span> Wait</span></div></button> : <button type="submit"  className="saveBtn" onClick={() => this.AddFeature()} >Save</button>}
                        <button className="cancelBtn" onClick={() => this.ResetForm()}>Cancel</button>
                    </div>
                </div>
                {/* {this.state.success_message ? <span style={{float:'left',color:'green'}}>{this.state.success_message}</span>  : ''} */}
            </div>
          </div>
          )
      }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: option => option.name,
    });

    return (

      <div>
        <Header brecum_name="ER" brecum_page="Add Feature" />
          <div className="right_col add-right_col view_crm_deal">
            <div className="intranet_body">
              <div className="fullViewfeature">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="topTitle">
                            <div className="view-title">Add Feature</div>
                        </div>
                    </div>
                </div>
                {this.getFeatureDetails()}
              </div>
              </div>
            </div>

            <div className="editLink_popup">
              <div className="modal fade" id="addLink" tabIndex="-1" role="dialog" aria-labelledby="Link" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                      <div className="modal-content">
                          <div className="modal-header">
                              <h4 className="modal-title">{this.state.form_type} Link</h4>
                              <button type="button" className="close" data-dismiss="modal">
                                  <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M31.5858 12L27.3431 7.75736C26.9526 7.36684 26.9526 6.73367 27.3431 6.34315C27.7337 5.95262 28.3668 5.95262 28.7573 6.34315L33 10.5858L37.2426 6.34315C37.6332 5.95262 38.2663 5.95262 38.6568 6.34315C39.0474 6.73367 39.0474 7.36683 38.6568 7.75736L34.4142 12L38.6568 16.2426C39.0474 16.6332 39.0474 17.2663 38.6568 17.6569C38.2663 18.0474 37.6332 18.0474 37.2426 17.6569L33 13.4142L28.7573 17.6569C28.3668 18.0474 27.7337 18.0474 27.3431 17.6569C26.9526 17.2663 26.9526 16.6332 27.3431 16.2426L31.5858 12Z" fill="#586472"/>
                                  </svg>  
                              </button>
                          </div>
                          <div className="modal-body">
                              <div className="row">
                                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                      <div className="inputBoxGroup">
                                          <label className="">Text to Display <span className="star">*</span></label>
                                          <input type="text" className="form-control" id="display_text" autoComplete="off" placeholder="Please Write Here" value={this.state.linkData['display_text']}  onChange={(e) => this.onChangeLink('display_text',e)} />

                                          <span className="error">{this.state.errors["display_text"]}</span>

                                      </div>
                                  </div>
                              </div>
                              <div className="row mt20">
                                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                      <div className="inputBoxGroup">
                                          <label className="">To what URL should this link go? <span className="star">*</span></label>
                                          <input type="text" className="form-control" id="display_link" autoComplete="off" placeholder="Please add link here" value={this.state.linkData['display_link']}  onChange={(e) => this.onChangeLink('display_link',e)} />
                                          <span className="error">{this.state.errors["display_link"]}</span>
                                      </div>
                                  </div>
                              </div>
                              <span className="error mb20">{this.state.errors["link"]}</span>
                              <div className="row mt30">
                                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                      <div className="btnGroup">
                                        {this.state.waiting ? <button type="submit" className="okBtn disabled" ><span> Wait</span></button> : <button type="submit"  className="okBtn" onClick={() => this.AddLink()} >
                                        Confirm</button>}
                                          <button className="cancelBtn" data-dismiss="modal">Cancel</button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>



          <div className="editLink_popup">
              <div className="modal fade" id="quiz_Pass" tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                      <div className="modal-content">
                          <div className="modal-header">
                              <h2 className="modal-title text-center">Success</h2>
                          </div>
                          <div className="modal-body">
                            <div className="icon_txt">
                              <i className="fal fa-check-circle"></i>
                              <span>Feature has been added successfully</span>
                            </div>
                            <p className = "text-center mt10">
                              <a className = "btn btn block" href = "/features">Go to Features</a>
                            </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
         
        </div>
    );
  }
}
export default AddFeature;



// WEBPACK FOOTER //
// ./src/components/feature/AddFeature.js